import { Stack, Box } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';
import { PromptLibraryIcon } from '../PromptLibraryIcon';

interface AllPromptsCategoryItemProps {
  totalCount: number;
  isSelected: boolean;
  onClick: () => void;
}

export const AllPromptsCategoryItem = ({
  totalCount,
  isSelected,
  onClick,
}: AllPromptsCategoryItemProps) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '40px',
        padding: '8px 12px 8px 8px',
        borderRadius: '8px',
        cursor: 'pointer',
        backgroundColor: isSelected ? colors.blue[100] : 'transparent',
        '&:hover': {
          backgroundColor: isSelected ? colors.blue[100] : colors.grey[100],
        },
      }}
    >
      <Stack direction="row" gap={1} alignItems="center">
        <PromptLibraryIcon icon="Archive" color={isSelected ? colors.blue[500] : undefined} />
        <Typography variant="body" color={isSelected ? colors.blue[500] : colors.grey[800]}>
          All Prompts
        </Typography>
      </Stack>

      <Typography variant="caption" color={isSelected ? colors.blue[500] : colors.grey[700]}>
        {totalCount}
      </Typography>
    </Box>
  );
};
